import useT from "utils/useT"

const NoResultsCard = () => {
  const t = useT()
  return (
    <div className="content">
      <div className="search-no-results">
        <div className="card card-style mx-0">
          <div dir="auto" className="content">
            <h4>{t.submit.noResult}</h4>
            <p>{t.submit.noResultSub}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoResultsCard
